import React from 'react'
import UserTable from './Components/UsersTable/UserTable'
import UserAndRollTable from './Components/UserRollTable/UserAndRollTable'
import EditModal from './Components/UserRollTable/EditModal'

const Privileges = () => {
    return (
        <div>
            {/* x---------------------------------x UserAndRollTable / UserTable Section x---------------------------------x */}
            <div className="card bg-white mx-0 px-0">
                <div className="card-body rounded">
                    <div className="row">
                        {/* x---------------------------------x UserAndRollTable x---------------------------------x */}
                        <div className="col-lg-6">
                            <div className="card border">
                                <div className="card-header">
                                    <h3 className="text-dark fs-5 fw-semibold">User &amp; Roles</h3>
                                </div>
                                <div className="card-body">
                                    <UserAndRollTable />
                                </div>
                            </div>
                        </div>
                        {/* x---------------------------------x UserTable Section x---------------------------------x */}
                        <div className="col-lg-6">
                            <div className="card border">
                                <div className="card-header">
                                    <h3 className="text-dark fs-5 fw-semibold">Users</h3>
                                </div>
                                <div className="card-body">
                                    <UserTable />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* x---------------------------------x User & Role Edit Modal Section x---------------------------------x */}
            <EditModal />
        </div>
    )
}

export default Privileges